<script setup lang="ts">
import type { IUser } from '../users/types'
import SelecionarPlano from '@/pages/admin/selecionar-plano/[id].vue'

definePage({
  meta: {
    action: 'read',
    subject: 'meuPlano',
  },
})
</script>

<template>
  <SelecionarPlano :suplier-id="useCookie<IUser>('userData').value?.supplier_selected_id" />
</template>
